import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'

const workflowHistoryStateSelector = state => state.approvals.workflowHistories
const approverHistoryStateSelector = state => state.approvals.approverHistories

const workflowHistorySelectorFunc = (entities, refs) => {
  return refs.map(id => entities['workflow_histories'][id])
}

const approverHistorySelectorFunc = (entities, refs) => {
  return refs.map(id => entities['workflow_approver_histories'][id])
}

const approverHistorySelector = createSelector(
  entitySelector,
  approverHistoryStateSelector,
  approverHistorySelectorFunc
)

const workflowHistorySelector = createSelector(
  entitySelector,
  workflowHistoryStateSelector,
  workflowHistorySelectorFunc
)

export {
  workflowHistorySelector,
  approverHistorySelector,
}
